import { Typography } from "@mui/material"
import React from "react"
import styled from "styled-components"

const StyledLine = styled.div`
  background: ${(p) => p.theme.colors.disable};
  height: 1px;
  opacity: 0.3;
  min-width: 100px;
  max-width: 100%;
`
const StyledLineWrapper = styled.div`
  text-align: center;
  margin-right: 10px;
  margin-left: 10px;
`

const StyledNumber = styled.div`
  color: ${(p) => p.theme.colors.black};
  font-size: 20px;
  fontfamily: "MazdaType, OENaPro, sans-serif;";
`

const StyledText = styled(Typography).attrs({ variant: "caption" })``

type PerformanceNumberProps = {
  text: string
  reference: React.Ref<HTMLInputElement>
  press?: boolean
  number?: string
}

const PerformanceNumber = ({
  reference,
  text,
  press,
  number,
}: PerformanceNumberProps) => {
  return (
    <StyledLineWrapper>
      <StyledNumber ref={reference}>{!press && number}</StyledNumber>
      <StyledLine></StyledLine>
      <StyledText>{text}</StyledText>
    </StyledLineWrapper>
  )
}

export default PerformanceNumber
